import React, { Component, Fragment } from 'react'
import { Link }             from "react-router-dom"
import { withRouter }       from "react-router"
//ELEM REACT16 CHANGE
import { Button, Icon, Modal, Table } from "semantic-ui-react";
import Responsive from "react-responsive"

@withRouter
class ReturnPageHeader extends Component {

    render() {
        const {referer, isRequest, activeStep = 0} = this.props
		return (
            /*        <Fragment>
            <Responsive minWidth={790} >
            
            </Responsive>
            <Responsive maxWidth={789} >

            </Responsive>
        </Fragment>*/
        <Fragment>
        <Responsive minWidth={790} >
        <div className="pt4 v-top">
            <h1 className="pl4"><b>Restanten</b></h1>
            <div className="checkout-steps-lindt">
            <Table className="" style={{border: "none"}}>
                <colgroup>
                    <col width="10%" />
                </colgroup>
                <thead>
                    <tr>
                        <td>
                            <b>Restantenerfassung</b>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td>      
							<div className={`step ${activeStep === 0 && "active"}`}><Link
							to={{
								pathname: "/return/quantity",
								search  : this.props.location.search
							}}> <span className="ttc dark-gray  pb4">{translate( "1. Stückmengen" )}</span> </Link></div>
                            <div className={`step ${activeStep === 1 && "active"}`}><Link
							to={{
								pathname: "/return/contactPerson",
								search  : this.props.location.search
							}}><span className="ttc dark-gray  pb4">{translate( "2. Ansprechpartner" )}</span> </Link></div>
                            <div className={`step ${activeStep === 2 && "active"}`}><Link
							to={{
								pathname: "/return/confirmation",
								search  : this.props.location.search
							}}><span className="ttc dark-gray pb4">{translate( "3. Kontrolle" )}</span> </Link></div>
                            <div className={`step ${activeStep === 3 && "active"}`}><Link
							to={{
								pathname: "/return/contact",
								search  : this.props.location.search
							}}><span className="ttc dark-gray pb4">{translate( "Kontakt" )}</span> </Link></div>
                                                        <div>
                                <Button primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name="arrow left" />Logout</Button>
                            </div>
                        </td> 
                    </tr>
                </tbody>
            </Table>
            </div>
            </div>
        </Responsive>

        <Responsive maxWidth={789} >
            <div className="checkout-steps-lindt">
            <Table className="pl7" style={{border: "none"}}>
                <colgroup>
                    <col width="10%" />
                </colgroup>
                <thead>
                    <tr>
                        <td>
                            <b>Restantenerfassung</b>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td>      
							<div className={`step ${activeStep === 0 && "active"}`}><Link
							to={{
								pathname: "/return/quantity",
								search  : this.props.location.search
							}}> <span className="ttc dark-gray  pb4">{translate( "1. Stückmengen" )}</span> </Link></div>
                            <div className={`step ${activeStep === 1 && "active"}`}><Link
							to={{
								pathname: "/return/contactPerson",
								search  : this.props.location.search
							}}><span className="ttc dark-gray  pb4">{translate( "2. Ansprechpartner" )}</span> </Link></div>
                            <div className={`step ${activeStep === 2 && "active"}`}><Link
							to={{
								pathname: "/return/confirmation",
								search  : this.props.location.search
							}}><span className="ttc dark-gray pb4">{translate( "3. Kontrolle" )}</span> </Link></div>
                            <div className={`step ${activeStep === 3 && "active"}`}><Link
							to={{
								pathname: "/return/contact",
								search  : this.props.location.search
							}}><span className="ttc dark-gray pb4">{translate( "Kontakt" )}</span> </Link></div>
                            <div>
                                <Button primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name="arrow left" />Logout</Button>
                            </div>
                        </td> 
                    </tr>
                </tbody>
            </Table>
            </div>
        </Responsive>
        </Fragment>
		)
    }
}

export default ReturnPageHeader;


// WEBPACK FOOTER //
// ./src/theme/lindt/pages/returnCheckout/ReturnPageHeader.js